exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ [hidden] {\n  display: none !important; }\n\n:host /deep/ .text-center {\n  overflow: hidden;\n  height: inherit;\n  width: inherit;\n  text-align: center; }\n\n:host /deep/ .text-center iframe {\n  height: inherit;\n  width: inherit; }\n\n.microblog-div {\n  height: 100%;\n  font-size: 4.6vw;\n  position: relative; }\n\n.microblog-div i {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n\n:host /deep/ .no-line-height-p p {\n  line-height: unset; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/media-preview-on-region/media-preview-on-region.scss
// module id = 1463
// module chunks = 18